import { Component, Input, OnInit } from '@angular/core';
import { Student } from '@df/interfaces';

@Component({
    selector: 'app-profile-user',
    templateUrl: './profile-user.component.html',
    styleUrls: ['./profile-user.component.scss']
})
export class ProfileUserComponent implements OnInit {
    @Input() student: Student;

    ngOnInit() {}
}
